export default function TimeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        d="M13.4596 1.91699V4.04199C13.4596 6.7804 11.2397 9.00033 8.5013 9.00033M8.5013 9.00033C5.76289 9.00033 3.54297 6.7804 3.54297 4.04199V1.91699M8.5013 9.00033C11.2397 9.00033 13.4596 11.2202 13.4596 13.9587V16.0837M8.5013 9.00033C5.76289 9.00033 3.54297 11.2202 3.54297 13.9587V16.0837"
        stroke="currentColor"
      />
      <path
        d="M2.83203 1.91699H14.1654M14.1654 16.0837H2.83203"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}
